/**
 * Tooltip
 *
 * @since 1.0.0
 */

const ToolTip = function () {
  const tooltips = document.querySelectorAll('.js-tooltip')
  if (!tooltips.length) return;
  [ ...tooltips ].forEach(tooltip => {
    tooltip.addEventListener('click', function () {
      this.classList.toggle('c-tooltip--is-active')
      const content = this.querySelector('.c-tooltip__content')
      content.getAttribute('aria-hidden') === 'true'
        ? content.setAttribute('aria-hidden', 'false')
        : content.setAttribute('aria-hidden', 'true')
    })
  })
}

export default ToolTip



// WEBPACK FOOTER //
// ./src/js/modules/ToolTip.js